

































import {Vue, Component, Prop} from 'vue-property-decorator';
import PortalInput from "@/components/common/PortalInput.vue";
import {ServiceDTO, UpdateServicePayload} from "@/components/payroll/business/services/ServiceDTO";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import Application from "@/state/Application";
import ServiceOrchestrator from "@/services/ServiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";

export type Mode = "view" | "edit"

@Component({
	components: {ServiceView, PortalInput}
})
export default class ServiceItem extends Vue {
	private mode: Mode = "view";

	private req: UpdateServicePayload = new UpdateServicePayload();

	@Prop()
	private service!: ServiceDTO

	@Prop({default: true})
	private disablable!: boolean

	@Prop({default: true})
	private mutable!: boolean


	toEdit() {
		this.req = new UpdateServicePayload(
			{
				serviceId: this.service.id,
				holderId: this.$wss.getCurrent.id,
				name: this.service.name,
				description: this.service.description,
				price: this.service.price * 100
			}
		)
		this.mode = "edit";
	}

	save() {
		Application.startLoading()
		ServiceOrchestrator.updateService(this.req).then(
			(res) => {
				this.service.id = res.data.id
				this.service.name = res.data.name
				this.service.price = res.data.price
				this.mode = "view"
				this.$emit("updated", res.data)
				Application.stopLoading()
			},
			err => processError(err, this)
		)
	}

	showDisableModal() {
		this.$modal.show(
			DeleteConfirmation,
			{
				targetName: "service",
				operationName: "disable",
				onDelete: this.disable
			},
			{
				styles: "z-index: 1000000"
			}
		)
	}

	disable() {
		if (this.service.id == null) return;
		Application.startLoading()
		ServiceOrchestrator.disableService(this.service.id, this.service.holder.id!).then(
			() => {
				Application.stopLoading()
				this.service.active = false
				this.mode = "view"
				this.$emit("disabled", this.service)
			},
			err => processError(err, this)
		)
	}
}
